// extracted by mini-css-extract-plugin
export default {"container":"CurrentColors_container__ccVDz","header":"CurrentColors_header__wOEB4","subtitle":"CurrentColors_subtitle__1A4gO"};